// extracted by mini-css-extract-plugin
export var item = "fk_tz";
export var text = "fk_gJ";